module.exports = __webpack_public_path__ + "static/media/0046_Medium.6c7eabb0.jpg";